import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";
import "@/index.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Apps from "@/pages/Apps";

// Globe route is heavy (three.js + react-globe.gl) — lazy-loaded so login,
// register, and the classic dashboard stay lightweight.
const GlobePage = lazy(() => import("@/pages/GlobePage"));

function GlobeLoading() {
  return (
    <div
      className="min-h-screen flex items-center justify-center speculo-grid-bg"
      data-testid="globe-route-loading"
    >
      <div className="speculo-glass rounded-sm px-6 py-4 text-cyan-300 uppercase tracking-widest text-sm font-mono">
        Loading orbital feed…
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/globe"
              element={
                <ProtectedRoute>
                  <Suspense fallback={<GlobeLoading />}>
                    <GlobePage />
                  </Suspense>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/apps"
              element={
                <ProtectedRoute>
                  <Apps />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/globe" replace />} />
            <Route path="*" element={<Navigate to="/globe" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
